enum BillingRemittanceActionType {
  DETAILS = 'DETAILS',
  GENERATE = 'GENERATE',
  OCCURRENCES = 'OCCURRENCES',
  PAYMENT_SLIP = 'PAYMENT_SLIP',
  REMOVE = 'REMOVE',
}

export default BillingRemittanceActionType;
